// extracted by mini-css-extract-plugin
module.exports = {"tableCellWrapper":"styles_tableCellWrapper__Y_cVi","cellWrapper":"styles_cellWrapper__GoW-9","rowTitle":"styles_rowTitle__27UyP","alignBottom":"styles_alignBottom__2IbRp"};